import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedUiTableModule} from '@snelstart/ui-table';
import {SharedUiButtonModule} from "@snelstart/ui-button";
import {SharedUiFileUploadModule} from "@snelstart/ui-file-upload";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {SharedUiDetailsModule} from "@snelstart/ui-details";
import {SharedUiDialogModule} from "@snelstart/ui-dialog";
import {SharedUiFormControlsModule} from "@snelstart/ui-form-controls";
import {SharedUiListModule} from "@snelstart/ui-list";
import {SharedUiModule} from "@snelstart/ui";
import {SharedUiIconModule} from "@snelstart/ui-icon";
import {SharedUiAlertModule} from "@snelstart/ui-alert";
import {SharedUiContextMenuModule} from "@snelstart/ui-context-menu";
import { FeatureTaxIncomeListComponent } from "./tax-income-list/feature-tax-income-list.component";

@NgModule({
  imports: [CommonModule,
    SharedUiTableModule,
    SharedUiButtonModule,
    SharedUiFileUploadModule,
    FormsModule,
    ReactiveFormsModule,
    SharedUiDetailsModule,
    SharedUiDialogModule,
    SharedUiFormControlsModule,
    SharedUiListModule,
    SharedUiModule,
    SharedUiIconModule,
    SharedUiAlertModule,
    SharedUiContextMenuModule, FeatureTaxIncomeListComponent],
    declarations: [],
    exports: [FeatureTaxIncomeListComponent],
})
export class FeatureTaxIncomeListModule {
}
